import { convertLegacyRouteRefs } from '@backstage/core-compat-api';
import {
  createComponentExtension,
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { CreateAppRouteBinder } from '@backstage/frontend-app-api';

import { ExternalRoutes, Routes, rootRouteRef } from './routes';

export const confidenceAdminPlugin = createPlugin({
  id: 'confidence-admin',
  routes: {
    ...Routes,
  },
  externalRoutes: {
    ...ExternalRoutes,
  },
});

export const bindAdminRoutes = (
  bind: CreateAppRouteBinder,
  extraRoutes?: Parameters<typeof convertLegacyRouteRefs>[0],
) => {
  bind(
    convertLegacyRouteRefs(confidenceAdminPlugin.externalRoutes),
    convertLegacyRouteRefs({ ...extraRoutes }),
  );
};

export const ConfidenceAdminPage = confidenceAdminPlugin.provide(
  createRoutableExtension({
    name: 'ConfidenceAdminPage',
    component: () =>
      import(
        /* webpackChunkName: "confidence-admin", webpackPrefetch: 10 */ './Router'
      ).then(m => m.Router),
    mountPoint: rootRouteRef,
  }),
);

export const ConfidenceAdminExtension = confidenceAdminPlugin.provide(
  createComponentExtension({
    name: 'ConfidenceAdminExtension',
    component: {
      lazy: () =>
        import(
          /* webpackChunkName: "confidence-admin-extension", webpackPrefetch: 10 */ './Router'
        ).then(m => m.Router),
    },
  }),
);
